module.exports = __webpack_public_path__ + "img/icon-arrow-right.6feddd71.svg";